<template>
  <v-col cols="12" sm="8">
    <v-row>
      <template
        v-if="
          showThirdPartyBillingSelect &&
            !selectedClient.clients_addresses.some(
              item => item.clients_address_type.title == 'Billing'
            )
        "
      >
        <v-col cols="12" sm="6">
          <h4>Billing Address</h4>
          <BillingAccount
            :items="[
              selectedClient?.clients_third_party_billing?.client_third_party
            ]"
          />
        </v-col>
      </template>
      <v-col
        cols="12"
        sm="6"
        v-for="address in client.clients_addresses"
        :key="address.clients_address_type_id"
      >
        <h4>
          {{
            (
              getById(
                "clients_address_types",
                address.clients_address_type_id
              ) || {}
            ).title
          }}
          Address
        </h4>
        <!-- <BillingAccount v-if="isBilling(address)" :checkbox-only="true" />
        <v-checkbox
          v-model="useMainAddressMap[address.clients_address_type_id]"
          @change="onUseMainAddressChange(address)"
          label="Is this the same as the main address?"
        ></v-checkbox> -->
        <v-text-field
          v-if="address.clients_address_type.title !== 'Billing'"
          v-model="address.address_1"
          :rules="rules.required"
          label="Address 1"
          :disabled="usesMainAddress(address)"
        ></v-text-field>
        <v-text-field
          v-if="address.clients_address_type.title !== 'Billing'"
          v-model="address.address_2"
          label="Address 2"
          :disabled="usesMainAddress(address)"
        ></v-text-field>
        <v-text-field
          v-if="address.clients_address_type.title !== 'Billing'"
          v-model="address.city"
          :rules="rules.required"
          label="City"
          :disabled="usesMainAddress(address)"
        ></v-text-field>
        <v-select
          v-if="address.clients_address_type.title !== 'Billing'"
          v-model="address.country_id"
          :rules="rules.required"
          :items="countries"
          item-value="id"
          item-text="country_name"
          label="Country"
          no-data-text="No Countries Available"
          :disabled="usesMainAddress(address)"
        ></v-select>
        <v-select
          v-if="
            filterById('states', address.country_id, 'country_id').length &&
              address.clients_address_type.title !== 'Billing'
          "
          v-model="address.state_id"
          :rules="rules.required"
          :items="filterById('states', address.country_id, 'country_id')"
          item-value="id"
          item-text="title"
          label="State/Province"
          no-data-text="No States/Provinces Available"
          :disabled="usesMainAddress(address)"
        ></v-select>
        <BillingAccount
          v-if="address.clients_address_type.title == 'Billing'"
          :items="
            selectedClient?.clients_third_party_billing?.client_third_party
              ? [
                  selectedClient?.clients_third_party_billing
                    ?.client_third_party
                ]
              : null
          "
        ></BillingAccount>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import rules from "@/utils/rules";
import BillingAccount from "@/components/clients/Addresses/BillingAccount";

const STORAGE_KEY = "client_useMainAddressMap";

function getUseMainAddressStorage() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

function saveUseMainAddressStorage(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function updateUseMainAddressForClient(clientId, addressTypeId, value) {
  const storage = getUseMainAddressStorage();
  let clientEntry = storage.find(entry => entry.client_id === clientId);

  if (!clientEntry) {
    clientEntry = {
      client_id: clientId,
      map: { [addressTypeId]: value }
    };
    storage.push(clientEntry);
  } else {
    clientEntry.map[addressTypeId] = value;
  }

  saveUseMainAddressStorage(storage);
}

function getUseMainAddressMapForClient(clientId) {
  const storage = getUseMainAddressStorage();
  const clientEntry = storage.find(entry => entry.client_id === clientId);
  return clientEntry ? clientEntry.map : {};
}

export default {
  name: "Addresses",
  components: { BillingAccount },
  data() {
    return {
      useMainAddressMap: {},
      rules: {
        required: [rules.required],
        email: [rules.email],
        postal_code: [rules.maxLength(10), rules.required]
      }
    };
  },
  computed: {
    ...mapGetters("baseData", [
      "countries",
      "states",
      "clients_address_types",
      "filterById",
      "getById"
    ]),
    ...mapState("clients", { clients: "items" }),
    ...mapGetters("clients", ["selectedClient"]),
    // ...mapMultiRowFields("clients", ["items[0].clients_addresses"]),
    ...mapFields("clients", [
      "useMainAddress",
      "client",
      "billing_only_client"
      // "items[0].third_party_billing"
    ]),
    hasBilling() {
      const billingTypeId = (
        this.getById("clients_address_types", "Billing", "title") || {}
      ).id;
      return this.clients_addresses.find(
        address => address.clients_address_type_id === billingTypeId
      );
    },
    showThirdPartyBillingSelect() {
      return (
        this.selectedClient?.third_party_billing ||
        !this.selectedClient?.clients_addresses?.some(
          item => item.clients_address_type.title == "Billing"
        )
      );
    }
  },
  methods: {
    ...mapMutations("clients", ["removeAddress"]),
    ...mapActions("clients", [
      "getClients",
      "updateClientAddresses",
      "getBillingOnlyClientId"
    ]),
    ...mapActions("clients", ["getClients"]),
    ...mapActions("baseData", ["getClientsAddressTypes"]),
    usesMainAddress(address) {
      // return this.useMainAddress.includes(address.clients_address_type_id);
      return !!this.useMainAddressMap[address.clients_address_type_id];
    },
    isBilling(address) {
      return (
        this.getById("clients_address_types", address.clients_address_type_id)
          .title === "Billing"
      );
    },
    beforeContinue() {
      return this.updateClientAddresses().catch(e => {
        console.error(e);
        return false;
      });
    },
    // onUseMainAddressChange(address) {
    //   // if (this.usesMainAddress(address)) {
    //   //   address.address_1 = this.client.address_1;
    //   // }
    //   const id = address.clients_address_type_id;

    //   if (this.useMainAddressMap[id]) {
    //     // Copy main address to this address
    //     address.address_1 = this.client.address_1;
    //     address.address_2 = this.client.address_2;
    //     address.city = this.client.city;
    //     address.country_id = this.client.country_id;
    //     address.state_id = this.client.state_id;
    //     address.postal_code = this.client.postal_code;
    //   }
    // },
    initializeUseMainAddressMap() {
      const savedMap = getUseMainAddressMapForClient(this.client.id);
      const map = {};

      this.client.clients_addresses.forEach(address => {
        const id = address.clients_address_type_id;
        map[id] =
          savedMap[id] != null
            ? savedMap[id]
            : this.isSameAsMainAddress(address);
      });

      this.useMainAddressMap = map;
    },
    isSameAsMainAddress(address) {
      return (
        address.address_1 === this.client.address_1 &&
        address.address_2 === this.client.address_2 &&
        address.city === this.client.city &&
        address.country_id === this.client.country_id &&
        address.state_id === this.client.state_id &&
        address.postal_code === this.client.postal_code
      );
    },
    onUseMainAddressChange(address) {
      const id = address.clients_address_type_id;
      const clientId = this.client.id;
      const value = this.useMainAddressMap[id];

      updateUseMainAddressForClient(clientId, id, value);

      if (value) {
        address.address_1 = this.client.address_1;
        address.address_2 = this.client.address_2;
        address.city = this.client.city;
        address.country_id = this.client.country_id;
        address.state_id = this.client.state_id;
        address.postal_code = this.client.postal_code;
      }
    }
  },
  watch: {
    "client.address_1"(newVal) {
      if (!this.client || !this.client.clients_addresses) return;

      this.client.clients_addresses.forEach(address => {
        if (this.usesMainAddress(address)) {
          address.address_1 = newVal;
        }
      });
    },
    "client.address_2"(newVal) {
      if (!this.client || !this.client.clients_addresses) return;

      this.client.clients_addresses.forEach(address => {
        if (this.usesMainAddress(address)) {
          address.address_2 = newVal;
        }
      });
    },
    "client.city"(newVal) {
      if (!this.client || !this.client.clients_addresses) return;

      this.client.clients_addresses.forEach(address => {
        if (this.usesMainAddress(address)) {
          address.city = newVal;
        }
      });
    },
    "client.country_id"(newVal) {
      if (!this.client || !this.client.clients_addresses) return;

      this.client.clients_addresses.forEach(address => {
        if (this.usesMainAddress(address)) {
          address.country_id = newVal;
        }
      });
    },
    "client.state_id"(newVal) {
      if (!this.client || !this.client.clients_addresses) return;

      this.client.clients_addresses.forEach(address => {
        if (this.usesMainAddress(address)) {
          address.state_id = newVal;
        }
      });
    },
    "client.postal_code"(newVal) {
      if (!this.client || !this.client.clients_addresses) return;

      this.client.clients_addresses.forEach(address => {
        if (this.usesMainAddress(address)) {
          address.postal_code = newVal;
        }
      });
    },
    "client.clients_addresses": {
      handler() {
        this.client.clients_addresses.forEach(address => {
          const id = address.clients_address_type_id;
          this.useMainAddressMap[id] = this.isSameAsMainAddress(address);
        });
      },
      deep: true
    },
    "client.id": {
      immediate: true,
      handler() {
        this.useMainAddressMap = {};

        if (this.client?.clients_addresses?.length) {
          this.client.clients_addresses.forEach(address => {
            this.$set(
              this.useMainAddressMap,
              address.clients_address_type_id,
              false
            );
          });
        }
      }
    }
  }
};
</script>

<style>
.selectedBilling * {
  color: #006940 !important;
}
</style>
